import script from "./CreateResourceButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateResourceButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"CreateResourceButton.vue"]])

export default __exports__